
import { combineReducers } from 'redux'

import app from './app'
import deliveries from './deliveries'
import msgDialog from './msgDialog'
import login from './login'
import orders from './orders'
import profile from './profile'
import sensors from './sensors'

let appReducer = combineReducers({
    app,
    deliveries,
    msgDialog,
    login,
    orders,
    profile,
    sensors
});

let rootReducer = (state, action)=>{
    return appReducer(state, action);
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js